import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ModalForms from "../component/ModalForms"

import "./AssignTasks.css";


const AssignTasks = () => {
  const [activeModal, setActiveModal] = useState(null);

  const [employees, setEmployees] = useState([]);
  const [assignments, setAssignments] = useState([]);

  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});

  const navigate = useNavigate();

  // ✅ Dummy Employees
  useEffect(() => {
    const dummyEmployees = [
      { _id: 1, user: { name: "Rahul Sharma" }, designation: "Manager" },
      { _id: 2, user: { name: "Amit Kumar" }, designation: "Developer" },
      { _id: 3, user: { name: "Sneha Gupta" }, designation: "Designer" },
    ];

    setEmployees(dummyEmployees);

    // ✅ Dummy Tasks
    const dummyTasks = [
      {
        _id: 101,
        title: "Website Redesign",
        description: "Update homepage UI",
        createdAt: new Date(),
        startDate: "2026-03-10",
        endDate: "2026-03-15",
        employee: dummyEmployees[0],
      },
      {
        _id: 102,
        title: "SEO Optimization",
        description: "Improve rankings",
        createdAt: new Date(),
        startDate: "2026-03-12",
        endDate: "2026-03-20",
        employee: dummyEmployees[1],
      },
    ];

    setAssignments(dummyTasks);
  }, []);

  // Edit
  const handleEdit = (assignment) => {
    setEditId(assignment._id);
    setEditForm({
      title: assignment.title,
      description: assignment.description,
      startDate: assignment.startDate,
      endDate: assignment.endDate,
      employee: assignment.employee?._id || "",
    });
  };

  const handleCancel = () => {
    setEditId(null);
    setEditForm({});
  };

  const handleSave = (id) => {
    const updated = assignments.map((a) =>
      a._id === id
        ? {
            ...a,
            ...editForm,
            employee: employees.find((e) => e._id == editForm.employee),
          }
        : a
    );

    setAssignments(updated);
    setEditId(null);
  };

  // Delete
  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this task?")) return;

    setAssignments(assignments.filter((a) => a._id !== id));
  };

  return (
    <div className="assign-tasks">
      <div className="page-header-tap">
        <h3>Tasks</h3>
        <div>
          <select className="export-select">
            <option>Export Excel</option>
            <option>Download PDF</option>
          </select>

          <button
            onClick={() => setActiveModal("addtask")}
            className="addbtn"
          >
            + Add Task
          </button>

           <ModalForms
            activeModal={activeModal}
            openModal={setActiveModal}
            closeModal={() => setActiveModal(null)}
          /> 
        </div>
      </div>

      <div className="table-div" style={{ marginTop: "20px" }}>
        <div className="table-header">
          <h5>Tasks list</h5>

          <select className="filterselect">
            <option>All</option>
            <option>Jan</option>
            <option>Feb</option>
            <option>Mar</option>
          </select>
        </div>

        {assignments.length === 0 ? (
          <p>No assignments yet.</p>
        ) : (
          <div className="table">
            <table>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Create Date</th>
                  <th>Assign to</th>
                  <th>Working Date</th>
                  <th>Description</th>
                  <th>Details</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {assignments.map((a) => (
                  <tr key={a._id}>
                    {/* Title */}
                    <td>
                      {editId === a._id ? (
                        <input
                          value={editForm.title}
                          onChange={(e) =>
                            setEditForm({
                              ...editForm,
                              title: e.target.value,
                            })
                          }
                        />
                      ) : (
                        a.title
                      )}
                    </td>

                    {/* Date */}
                    <td>
                      {new Date(a.createdAt).toLocaleDateString()}
                    </td>

                    {/* Employee */}
                    <td>
                      {editId === a._id ? (
                        <select
                          value={editForm.employee}
                          onChange={(e) =>
                            setEditForm({
                              ...editForm,
                              employee: e.target.value,
                            })
                          }
                        >
                          <option value="">Select</option>
                          {employees.map((emp) => (
                            <option key={emp._id} value={emp._id}>
                              {emp.user.name}
                            </option>
                          ))}
                        </select>
                      ) : (
                        `${a.employee?.user.name} (${a.employee?.designation})`
                      )}
                    </td>

                    {/* Working Date */}
                    <td>
                      {editId === a._id ? (
                        <>
                          <input
                            type="date"
                            value={editForm.startDate}
                            onChange={(e) =>
                              setEditForm({
                                ...editForm,
                                startDate: e.target.value,
                              })
                            }
                          />
                          {" - "}
                          <input
                            type="date"
                            value={editForm.endDate}
                            onChange={(e) =>
                              setEditForm({
                                ...editForm,
                                endDate: e.target.value,
                              })
                            }
                          />
                        </>
                      ) : (
                        `${new Date(
                          a.startDate
                        ).toLocaleDateString()} - ${new Date(
                          a.endDate
                        ).toLocaleDateString()}`
                      )}
                    </td>

                    {/* Description */}
                    <td>
                      {editId === a._id ? (
                        <input
                          value={editForm.description}
                          onChange={(e) =>
                            setEditForm({
                              ...editForm,
                              description: e.target.value,
                            })
                          }
                        />
                      ) : (
                        a.description
                      )}
                    </td>

                    {/* Details */}
                    <td>
                      <button
                        className="assign-tasks__detail-button"
                        onClick={() => navigate(`/tasks/${a._id}`)}
                      >
                        Details
                      </button>
                    </td>

                    {/* Action */}
                    <td>
                      {editId === a._id ? (
                        <>
                          <button
                            onClick={() => handleSave(a._id)}
                            className="statusbox green-bg"
                          >
                            Save
                          </button>

                          <button
                            onClick={handleCancel}
                            className="statusbox red-bg"
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={() => handleEdit(a)}
                            className="statusbox green-bg"
                          >
                            Edit
                          </button>

                          <button
                            onClick={() => handleDelete(a._id)}
                            className="statusbox red-bg"
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignTasks;